import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { createContext, useReducer, useEffect } from "react";
export const UtilitiesValue = createContext(null);
export const UtilitiesDisbatch = createContext(null);

const reducer = (state, action) => {
  const newState = { ...state };
  switch (action.type) {
    case "set":
      return { ...newState, utilities: action.value };
    case "setAdd":
      return { ...newState, add: action.value };
    case "setEditor":
      return { ...newState, editor: action.value };
    case "setOpen":
      return { ...newState, open: action.value };
    default:
      return newState;
  }
};

export default function UtilitiesContext({ children }) {
  const [state, dispatch] = useReducer(reducer, {
    utilities: [],
    add: false,
    editor: {},
    open: false,
  });
  const { appId, type, pageId } = useParams();

  useEffect(() => {
    if (appId && pageId) {
      db.collection("apps")
        .doc(appId)
        .collection(type)
        .doc(pageId)
        .collection("utilities")
        .orderBy("order")
        .get()
        .then((snap) => {
          const utilites = snap.docs.map((doc) => {
            return { ...doc.data(), id: doc.id };
          });
          dispatch({ type: "set", value: utilites });
        });
    }
  }, [appId, pageId]);

  useEffect(() => {
    if (appId && pageId && state.utilities.length > 0) {
      const batch = db.batch();
      state.utilities.forEach((u, index) => {
        batch.set(
          db
            .collection("apps")
            .doc(appId)
            .collection(type)
            .doc(pageId)
            .collection("utilities")
            .doc(u.id),
          { ...u, order: index }
        );
      });
      batch.commit();
    }
  }, [state]);

  return (
    <UtilitiesValue.Provider value={state}>
      <UtilitiesDisbatch.Provider value={dispatch}>
        {children}
      </UtilitiesDisbatch.Provider>
    </UtilitiesValue.Provider>
  );
}
